// GlobalErrorScreen.js
import React from "react";
import "./GlobalErrorScreen.css"; // Optional: for styling

function GlobalErrorScreen() {
  return (
    <div className="global-error-screen">
      <h1>Application Unavailable</h1>
      <p>Due to network errors, this application is currently down.</p>
      <p>Please try again in about an hour.</p>
    </div>
  );
}

export default GlobalErrorScreen;
